<template>
  <IconButton
    v-if="isShareApiSupported"
    icon="share"
    class="share-button"
    @click="handleShareClick"
  >
    <span class="u__visually-hidden">Share</span>
  </IconButton>
</template>

<script>
import { mapState } from "vuex";
import { unwrapNodes } from "@/helpers/graphql";
import IconButton from "@/components/IconButton.vue";

export default {
  name: "ShareButton",
  components: {
    IconButton,
  },
  data() {
    return {
      isShareApiSupported: false,
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    productTitle() {
      return this.product?.title;
    },
    productUrl() {
      return window.location.href;
    },
    productImage() {
      const allImages = this.product?.images
        ? unwrapNodes(this.product?.images?.edges)
        : [];

      return allImages[0].smallMedia;
    },
  },
  created() {
    this.isShareApiSupported = !!navigator.share;
  },
  methods: {
    async handleShareClick() {
      try {
        await navigator.share({
          title: this.productTitle,
          url: `${this.productUrl}?utm_source=pdp_share_button&utm_medium=referral`,
        });

        console.log("Content shared successfully!");

        window.dataLayer.push({
          event: "product_share_click",
          method: "share_button",
          location: "product_page",
          product_name: this.productTitle,
        });

        const VWO = window.VWO || [];
        VWO.event("productShareClick", {
          productshareclick: 1,
        });
      } catch (error) {
        console.log("There was an error sharing:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share-button.button--icon {
  font-size: 24px;
  padding: 12px;

  ::v-deep(.icon) {
    margin-right: 0;
  }
}
</style>
